import axios from "axios";

export const getUsersByCompany = async (userData) => {
  let res = await axios.post(`https://infini8ai.herokuapp.com/users`, {
    request: {
      method: "getUsersByCompany",
      data: userData,
    },
  });
  let json = res.data.response.data;
  return json;
};
export const updateUser = async (userData) => {
  let res = await axios.post(`https://infini8ai.herokuapp.com/users`, {
    request: {
      method: "updateUser",
      data: userData,
    },
  });
  let json = res.data.response.data;
  return json;
};

export const deleteUser = async (userData) => {
  let res = await axios.post(`https://infini8ai.herokuapp.com/users`, {
    request: {
      method: "deleteUser",
      data: userData,
    },
  });
  let json = res.data.response.data;
  return json;
};
